import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import { CREATED_THEME, GLOBAL_STYLES } from '../constants';

const createWrapRootElement = () => ({ element }: any) => {
  return (
    <React.StrictMode>
      <React.Fragment>
        <CssBaseline />
        <ThemeProvider theme={CREATED_THEME}>
          <GlobalStyles styles={GLOBAL_STYLES}/>
          {element}
        </ThemeProvider>
      </React.Fragment>
    </React.StrictMode>
  );
}

export default createWrapRootElement;